import { Component, Input } from '@angular/core';
import { BaseInquiryOfferLegendItemInterface } from '../../_interfaces/base-inquiry-offer-legend-item.interface';

@Component({
  selector: 'base-inquiry-offer-legend-item',
  templateUrl: './base-inquiry-offer-legend-item.component.html',
})
export class BaseInquiryOfferLegendItemComponent {
  @Input({ required: true }) legendItem: BaseInquiryOfferLegendItemInterface;
}
